/* ============================================================
   DEVIS PAGE — formulaire inline multi-step (4 étapes)
   Step 1 Type rack · 2 Surface · 3 Délai · 4 Coordonnées (+ upload optionnel)
   Auto-advance sur radio · tél international E.164 · upload base64 non bloquant
   Endpoint Make partagé → lead_type: 'devis-rack-page'
   ============================================================ */
(function () {
  'use strict';
  const root = document.getElementById('devis-page-form-root');
  if (!root) return;

  const form = root.querySelector('#devis-page-form');
  const steps = Array.from(root.querySelectorAll('.dp-step'));
  const progressFill = root.querySelector('[data-progress-fill]');
  const progressCurrent = root.querySelector('[data-step-current]');
  const btnBack = root.querySelector('[data-step-back]');
  const btnNext = root.querySelector('[data-step-next]');
  const btnSubmit = root.querySelector('[data-step-submit]');
  const navFooter = root.querySelector('[data-nav-footer]');
  const ENDPOINT = root.getAttribute('data-endpoint');
  const TOTAL_STEPS = 4;
  const MAX_FILE_BYTES = 4 * 1024 * 1024; // 4 Mo
  let currentStep = 1;

  function goToStep(n) {
    currentStep = n;
    steps.forEach(s => s.classList.remove('is-active'));
    const target = root.querySelector(`.dp-step[data-step="${n}"]`);
    if (target) target.classList.add('is-active');
    if (typeof n === 'number') {
      if (progressFill) progressFill.style.width = (n / TOTAL_STEPS) * 100 + '%';
      if (progressCurrent) progressCurrent.textContent = n;
      navFooter.removeAttribute('data-hidden');
      btnBack.toggleAttribute('data-hidden', n === 1);
      btnNext.toggleAttribute('data-hidden', n === TOTAL_STEPS);
      btnSubmit.toggleAttribute('data-hidden', n !== TOTAL_STEPS);
    } else {
      navFooter.setAttribute('data-hidden', '');
      if (progressFill) progressFill.style.width = '100%';
    }
    const card = root.querySelector('.dp-card');
    if (card && typeof n === 'number' && n > 1) {
      card.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  }

  function validateCurrentStep() {
    const target = root.querySelector(`.dp-step[data-step="${currentStep}"]`);
    if (!target) return false;
    if (currentStep <= 3) {
      const radios = target.querySelectorAll('input[type="radio"]');
      if (!Array.from(radios).some(r => r.checked)) {
        target.classList.add('shake');
        setTimeout(() => target.classList.remove('shake'), 400);
        return false;
      }
      return true;
    }
    if (currentStep === 4) {
      let valid = true;
      target.querySelectorAll('input[required]').forEach(input => {
        if (!input.value.trim() || !input.checkValidity()) { input.reportValidity(); valid = false; }
      });
      return valid;
    }
    return true;
  }

  btnNext.addEventListener('click', () => { if (validateCurrentStep() && currentStep < TOTAL_STEPS) goToStep(currentStep + 1); });
  btnBack.addEventListener('click', () => { if (currentStep > 1) goToStep(currentStep - 1); });

  root.querySelectorAll('#devis-page-form input[type="radio"]').forEach(radio => {
    radio.addEventListener('change', () => {
      if (currentStep <= 3) setTimeout(() => { if (currentStep <= 3) goToStep(currentStep + 1); }, 260);
    });
  });

  // ---- Téléphone (E.164) ----
  function normalizePhone(number, dial) {
    if (!number) return '';
    let c = number.replace(/[^\d+]/g, '');
    if (c.charAt(0) === '+') return c;
    if (c.substring(0, 2) === '00') return '+' + c.substring(2);
    if (!dial) return c ? '+' + c : '';
    if (c.charAt(0) === '0') c = c.substring(1);
    return dial + c;
  }
  function validatePhone(number, lengths) {
    if (!number) return false;
    const d = number.replace(/[^\d]/g, '');
    const nat = d.charAt(0) === '0' ? d.substring(1) : d;
    return lengths.indexOf(nat.length) !== -1;
  }
  function setupPhone(wrap) {
    const select = wrap.querySelector('[data-phone-country]');
    const input = wrap.querySelector('[data-phone-input]');
    if (!select || !input) return;
    const lengths = () => (select.options[select.selectedIndex].getAttribute('data-lengths') || '')
      .split(',').map(n => parseInt(n.trim(), 10)).filter(n => !isNaN(n));
    const check = () => wrap.setAttribute('data-phone-state', input.value.trim() && validatePhone(input.value.trim(), lengths()) ? 'valid' : '');
    input.addEventListener('input', check); select.addEventListener('change', check); check();
  }
  root.querySelectorAll('.dp-field-phone').forEach(setupPhone);

  function getPhone() {
    const wrap = form.querySelector('.dp-field-phone');
    if (!wrap) return { e164: '', raw: '', country: '' };
    const select = wrap.querySelector('[data-phone-country]');
    const input = wrap.querySelector('[data-phone-input]');
    if (!input || !input.value) return { e164: '', raw: '', country: select ? select.value : '' };
    const dial = select.options[select.selectedIndex].getAttribute('data-dial') || '';
    return { e164: normalizePhone(input.value, dial), raw: input.value, country: select.value };
  }

  // ---- Upload optionnel (base64, non bloquant) ----
  const fileInput = form.querySelector('#dp-file');
  const fileLabel = root.querySelector('[data-file-label]');
  if (fileInput) {
    fileInput.addEventListener('change', () => {
      const f = fileInput.files[0];
      if (!f) { if (fileLabel) fileLabel.textContent = 'Joindre un plan ou une photo (optionnel)'; return; }
      if (f.size > MAX_FILE_BYTES) {
        if (fileLabel) fileLabel.textContent = 'Fichier trop lourd (max 4 Mo) — envoyez-le par email';
        fileInput.value = '';
        return;
      }
      if (fileLabel) fileLabel.textContent = '📎 ' + f.name;
    });
  }
  function readFileB64() {
    return new Promise(resolve => {
      const f = fileInput && fileInput.files[0];
      if (!f || f.size > MAX_FILE_BYTES) return resolve(null);
      const r = new FileReader();
      r.onload = () => resolve({ name: f.name, type: f.type, base64: String(r.result).split(',')[1] || '' });
      r.onerror = () => resolve(null);
      r.readAsDataURL(f);
    });
  }

  async function submitLead() {
    const data = Object.fromEntries(new FormData(form).entries());
    const phone = getPhone();
    const email = (data.email || '').trim();
    const file = await readFileB64();
    const payload = {
      source: 'devis-page',
      lead_type: 'devis-rack-page',
      submitted_at: new Date().toISOString(),
      page_url: window.location.href,
      prenom: data.prenom || '', nom: data.nom || '',
      email: email, email_domain: email.indexOf('@') > -1 ? email.split('@')[1].toLowerCase() : '',
      telephone: phone.e164, telephone_raw: phone.raw, telephone_country: phone.country,
      entreprise: data.entreprise || '', message: data.message || '',
      type_rack: data.typeRack || '', surface: data.surface || '', delai: data.delai || '',
      plan_file_name: file ? file.name : '', plan_file_type: file ? file.type : '',
      plan_file_base64: file ? file.base64 : '',
      utm_source: new URLSearchParams(location.search).get('utm_source') || 'direct',
      utm_campaign: new URLSearchParams(location.search).get('utm_campaign') || '',
      utm_term: new URLSearchParams(location.search).get('utm_term') || '',
      utm_medium: new URLSearchParams(location.search).get('utm_medium') || ''
    };
    if (window.saLeadAttribution) { try { Object.assign(payload, window.saLeadAttribution()); } catch (e) {} }
    (window.saSendLead ? window.saSendLead(payload) : fetch(ENDPOINT, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) }))
      .catch(err => console.error('[devis-page] webhook error:', err));
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (!validateCurrentStep()) return;
    submitLead();
    goToStep('success');
  });

  goToStep(1);
})();
